"use client"

import { Heart } from "lucide-react"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { useWishlist } from "@lib/context/wishlist-context"

export default function WishlistLink() {
  const { count } = useWishlist()

  return (
    <LocalizedClientLink
      className="relative flex items-center gap-1.5 text-gray-900 hover:opacity-80 px-2 py-1.5 rounded transition-opacity duration-200"
      href="/wishlist"
    >
      <Heart className="w-5 h-5" strokeWidth={1.5} />
      <span>Wishlist</span>
      {count > 0 && (
        <span className="absolute -top-1.5 -left-1.5 w-4 h-4 bg-brand-accent text-white text-[10px] font-bold rounded-full flex items-center justify-center">
          {count > 9 ? "9+" : count}
        </span>
      )}
    </LocalizedClientLink>
  )
}
